import {
    initializeFaro,
    getWebInstrumentations,
    ReactIntegration,
    createReactRouterV6DataOptions,
} from '@grafana/faro-react';
import { matchRoutes } from 'react-router-dom';

let faro: ReturnType<typeof initializeFaro> | undefined;

export function initFaro() {
    if (typeof window === 'undefined') return;
    if (faro) return faro;

    const url = process.env.REACT_APP_FARO_COLLECTOR_URL;
    const env = process.env.REACT_APP_WEB_VITALS_ENV;
    const apiKey = process.env.REACT_APP_PUBLIC_FARO_API_KEY;

    if (!url || !env || env === 'local') return;

    faro = initializeFaro({
        url,
        ...(apiKey ? { apiKey } : {}),
        app: {
            name: 'pw-ambassador',
            version: process.env.REACT_APP_PP_CLIENT_VERSION ?? '0.0.0',
            environment: env,
        },
        instrumentations: [
            ...getWebInstrumentations(),
            new ReactIntegration({
                router: createReactRouterV6DataOptions({
                    matchRoutes,
                }),
            }),
        ],
    });

    return faro;
}